'use client';

import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

import { useCustomSearchParams } from '@lamesarv-sdk/hooks';
import { getScheduleDay } from '@/tools/locations';

import { ICollectionLocation } from '@/types/cms';

dayjs.extend(utc);
dayjs.extend(timezone);

interface ILocationImageAndInfoStatusProps {
  location: ICollectionLocation;
}

export const LocationImageAndInfoStatus = ({ location }: ILocationImageAndInfoStatusProps) => {
  const { searchParams } = useCustomSearchParams();

  let customNow: dayjs.Dayjs | undefined = undefined;

  const debugAddTime = searchParams.get('add-time');
  const debugSetTime = searchParams.get('set-time');

  if (debugAddTime) {
    const hours = parseInt(debugAddTime);
    if (!isNaN(hours)) {
      customNow = dayjs().tz(dayjs.tz.guess()).add(hours, 'hour');
    }
  }

  if (debugSetTime) {
    const parsed = dayjs(debugSetTime);
    if (parsed.isValid()) {
      customNow = parsed.tz(dayjs.tz.guess(), true);
    }
  }

  const timeSchedule = getScheduleDay({
    state: location.sales_state || '',
    city: location.sales_city || '',
    schedule_sunday: location.sales_schedule_sunday || '',
    schedule_weekdays: location.sales_schedule_weekdays || '',
    schedule_saturday: location.sales_schedule_saturday || '',
    asTimeZone: dayjs.tz.guess(),
    customNow,
  });

  const StatusClosed = () => <div className="text-[14px] text-red-500">Closed</div>;
  const StatusOpen = () => <div className="text-[14px] text-green-500">Open</div>;

  if (timeSchedule.defaultClosed) {
    return <StatusClosed />;
  }

  const now = customNow || dayjs().tz(dayjs.tz.guess());

  const isOpen = now.isBetween(timeSchedule.startLocal, timeSchedule.endLocal, null, '[)');

  return (
    <div className="flex flex-row gap-1">
      {isOpen ? <StatusOpen /> : <StatusClosed />}
      <div className="text-[14px] text-black-350">&#x25CF;</div>
      <div className="text-[14px] text-black-350">
        {isOpen && `Closes at ${timeSchedule.end?.format('h:mm a')}`}
        {!isOpen && `Opens at ${timeSchedule.start?.format('h:mm a')}`}
      </div>
    </div>
  );
};
